/**
 * 不跳转逻辑梳理 403001【客户受限制】、409010、409012、409013、409014、600004、600005、600008、600009、900000、980000、990000、
 * 重新创单逻辑 403005、409015
 * 重新刷新页面逻辑 600000（key无效页面跳转无效页面）、600001、600002
 *
 *  code 为 409010，409013，403005 -- 跳转到 cancelUrl，需要重新发起创单
 *  code 为 409012 -- 支付失败，跳转到失败页
 *  code 为 409014 -- 卡余额不足，允许用户修改信息再次发起支付
 *  code 为 600000 -- Key 无效
 *  code 为 600001 -- token 无效，提示页面已失效，重新调用初始化，刷新 token 和公钥
 *  code 为 600002 -- RSA 验证无效，重新调用初始化，刷新token和公钥
 *  code 为 600005 -- 短信验证失败
 *  code 为 900000，980000 -- 提示系统繁忙
 *  code 为 990000，409015 -- 按支付失败处理
 *
 *  1.交易成功文案修改为“Transaction successful. Reference Number: xxxxxxxxxxxx.” （支付成功，订单号为：xxxxxxxx）
 *  2.交易失败但可重复发起时，code 为409013【支付被拒】，403005【金额超限】，409015【支付超时】 -- 跳转到 cancelUrl，需要重新发起创单文案修改为 “Transaction unsuccessful, please try again . (Reference Number: xxxxxxxxxxx)” （支付失败，请重试...订单号为：xxxxxxxx）
 *  3.409014【余额不足】 “Transaction rejected, please contact your bank . (Reference Number: xxxxxxxxxxx)” （支付被拒绝，请联系您的发卡行，订单号为：xxxxxxxx）
 *  说明：Reference Number使用我方的订单号
 * 【1】第一个更改成功页面文案
 * 【2】第二个 Transaction unsuccessful, please try again. Reference Number: xxxxxxxxxxx
 * 【3】第三个 Transaction rejected, please contact your bank. Reference Number: xxxxxxxxxxx
 */

export function resCodeMsg(props, code) {
  const { intl } = props;
  const { formatMessage } = intl;
  const intlMsg = {
    200000: formatMessage({ id: 'ga-checkout.success' }),
    200100: formatMessage({ id: 'ga-checkout.error-200100' }),
    401005: formatMessage({ id: 'ga-checkout.error-401005' }),
    400004: formatMessage({ id: 'ga-checkout.error-400004' }),
    403006: formatMessage({ id: 'ga-checkout.error-403006' }),
    409011: formatMessage({ id: 'ga-checkout.error-409011' }),
    409015: formatMessage({ id: 'ga-checkout.error-409015' }),
    409016: formatMessage({ id: 'ga-checkout.error-409016' }),
    409123: formatMessage({
      id: 'ga-checkout.error-409123'
    }),
    422015: formatMessage({ id: 'ga-checkout.error-422015' }),
    422016: formatMessage({ id: 'ga-checkout.error-422016' }),
    422017: formatMessage({ id: 'ga-checkout.error-422017' }),
    422019: formatMessage({ id: 'ga-checkout.error-422019' }),
    423000: formatMessage({ id: 'ga-checkout.error-423000' }),
    423005: formatMessage({ id: 'ga-checkout.error-423005' }),
    423007: formatMessage({ id: 'ga-checkout.error-423007' }),
    500900: formatMessage({ id: 'ga-checkout.error-500900' }),
    600000: formatMessage({ id: 'ga-checkout.error-600000' }),
    600007: formatMessage({ id: 'ga-checkout.error-600007' }),
    600008: formatMessage({ id: 'ga-checkout.error-600008' }),
    980000: formatMessage({ id: 'ga-checkout.error-980000' }),
    990000: formatMessage({ id: 'ga-checkout.error-990000' }),
    'C131': formatMessage({ id: 'ga-checkout.error-C131' }),
    'C320': formatMessage({ id: 'ga-checkout.error-C320' }),
    'C121': formatMessage({ id: 'ga-checkout.error-C121' }),
    'C122': formatMessage({ id: 'ga-checkout.error-C122' }),
    'C126': formatMessage({ id: 'ga-checkout.error-C126' }),
    'C124': formatMessage({ id: 'ga-checkout.error-C124' }),
    'P900': formatMessage({ id: 'ga-checkout.error-P900' }),
  };
  const defaultMsg = formatMessage({ id: 'ga-checkout.error-400004' });
  return intlMsg[code] || defaultMsg;
}
